module.exports = "https://static.wmbcdn.com/uniweb/images/1fd09c1ecaa3f7c0c880807d8d170894.svg";